export class CustomScrollbar {
  constructor(scrollContainer) {
    this.scrollContainer = scrollContainer;
    this.content = scrollContainer.querySelector('.scroll-content');
    this.customScrollbar = scrollContainer.querySelector('.custom-scrollbar');
    if(this.customScrollbar == null) { return; }
    this.isDragging = false;
    this.startDragY = 0;
    this.startScrollTopContent = 0;
    this.currentScrollPosition = 0;
    this.currentDelta = 0;
    this.mask = null;

    this.onMouseMoveBind = this.onMouseMove.bind(this);
    this.onMouseUpBind = this.onMouseUp.bind(this);

    // Инициализируем скроллбар
    this.initialize();
    this.initializeObserver();
    this.createMask();
  }

  // Создаем маску для блокировки контента
  createMask() {
    this.mask = document.createElement('div');
    this.mask.classList.add('mask');
    this.mask.style.position = 'fixed';
    this.mask.style.top = '0';
    this.mask.style.left = '0';
    this.mask.style.width = '100vw';
    this.mask.style.height = '100vh';
    this.mask.style.background = 'rgba(0, 0, 0, 0)'; // Прозрачная маска
    this.mask.style.zIndex = '200000';
    this.mask.style.display = 'none'; // Скрываем маску по умолчанию
    this.content.appendChild(this.mask);
  }

  initialize() {
    const div = document.createElement('div');
    div.classList.add('content');
    this.content.append(div.appendCollection(this.content.children));
    this.content = div;
    // Обновляем размеры скроллбара
    this.updateCustomScrollbar();
    this.updateScrollbarPosition();

    // События
    this.scrollContainer.addEventListener('scroll', () => this.updateScrollbarPosition());
    window.addEventListener('resize', () => this.updateCustomScrollbar());

    // Добавляем обработчики для перетаскивания скроллбара
    this.customScrollbar.addEventListener('mousedown', (e) => this.startDrag(e));
  }

  initializeObserver() {
    // Инициализация MutationObserver для отслеживания изменений в scrollContainer
    this.observer = new MutationObserver(() => {
      this.updateCustomScrollbar();
      this.updateScrollbarPosition();
    });

    this.observer.observe(this.scrollContainer, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['style', 'class'] // Можете добавить другие атрибуты по необходимости
    });
  }

  updateCustomScrollbar() {
    const containerHeight = this.scrollContainer.offsetHeight;

    const contentHeight = this.content.scrollHeight;
    var scrollbarHeight = (containerHeight / contentHeight) * containerHeight;
    if (this.customScrollbar) {
      this.customScrollbar.hidden = contentHeight <= scrollbarHeight - 10 ? true : false;
      if (scrollbarHeight < containerHeight / 10) scrollbarHeight = containerHeight / 10;
      this.customScrollbarheight = scrollbarHeight;
      this.customScrollbar.style.height = `${scrollbarHeight}px`;
    }
  }

  updateScrollbarPosition() {
    if (this.isDragging) return;
    if (!this.customScrollbar) return;

    const deltaY = this.scrollContainer.scrollTop;
    const paddingTop = parseFloat(getComputedStyle(this.scrollContainer).paddingTop);
    const paddingBottom = parseFloat(getComputedStyle(this.scrollContainer).paddingBottom);

    const containerHeight = this.scrollContainer.offsetHeight;
    const contentHeight = this.content.offsetHeight + paddingTop + paddingBottom;

    const scrolHight = (containerHeight - this.customScrollbarheight) / (contentHeight - containerHeight);
    const newContentTop = scrolHight * deltaY;
    const logData = {
      del: deltaY,
      cotH: containerHeight,
      conH: contentHeight,
      // cbH: this.customScrollbarheight,
      // scrolHight,
      newContentTop
    };

    // console.log(logData); // Логируем объект с данными
    this.customScrollbar.style.top = `${deltaY + newContentTop}px`;
    this.currentScrollPosition = deltaY - newContentTop;
  }

  startDrag(e) {
    document.querySelector('body').classList.toggle('no-select', true);
    this.isDragging = true;
    this.startDragY = e.clientY;
    this.startScrollTopContent = this.content.scrollTop;
    this.startScrollTopScrollbar = parseInt(this.customScrollbar.style.top);

    // Показываем маску при начале перетаскивания
    this.mask.style.display = 'block';

    document.addEventListener('mousemove', this.onMouseMoveBind);
    document.addEventListener('mouseup', this.onMouseUpBind);
  }

  onMouseMove(e) {
    if (!this.isDragging) return;

    const deltaY = e.clientY - this.startDragY + this.currentScrollPosition;
    // const deltaY = e.clientY - this.startDraggY + (this.scrollContainer.scrollTop - this.startScrollTopContent);

    const paddingTop = parseFloat(getComputedStyle(this.scrollContainer).paddingTop);
    const paddingBottom = parseFloat(getComputedStyle(this.scrollContainer).paddingBottom);

    const containerHeight = this.scrollContainer.offsetHeight;
    const contentHeight = this.content.offsetHeight + paddingTop + paddingBottom;

    const scrolHight = (contentHeight - containerHeight) / (containerHeight - this.customScrollbarheight);
    // Пропорциональное смещение контента
    const scrollRatio = deltaY / containerHeight;
    const scrollbarTop = this.startScrollTopContent + scrollRatio * containerHeight;
    const newContentTop = scrolHight * deltaY;

    const logData = {
      deltaY,
      startDraggY: this.startDragY,
      curretScrollPosition: this.currentScrollPosition,
      clientY: e.clientY,
      containerHeight,
      contentHeight,
      scrolHight,
      scrollRatio,
      scrollbarTop,
      newContentTop
    };
    // console.log(logData);
    // Ограничиваем движение контента
    if (newContentTop < 0) {
      this.scrollContainer.scrollTop = 0;
    } else if (newContentTop > contentHeight - containerHeight) {
      this.scrollContainer.scrollTop = contentHeight - containerHeight;
    } else {
      this.scrollContainer.scrollTop = newContentTop;
    }

    if (scrollbarTop < 0) {
      this.customScrollbar.style.top = 0;
      this.currentDelta = 0;
    } else if (scrollbarTop > containerHeight - this.customScrollbarheight) {
      this.customScrollbar.style.top = `${contentHeight}`;
    } else {
      this.customScrollbar.style.top = `${scrollbarTop + newContentTop}px`;
      this.currentDelta = deltaY;
    }
  }

  onMouseUp(e) {
    document.querySelector('body').classList.toggle('no-select', false);
    e.preventDefault(); // Предотвращаем стандартное поведение
    e.stopPropagation(); // Останавливаем всплытие события

    setTimeout(() => {
      this.isDragging = false;
      this.currentScrollPosition = this.currentDelta;
    }, 10);
    document.removeEventListener('mousemove', this.onMouseMoveBind);
    document.removeEventListener('mouseup', this.onMouseUpBind);

    // Скрываем маску при завершении перетаскивания
    this.mask.style.display = 'none';
  }
}
